/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AdminIndexRouteImport } from './routes/_admin/index'
import { Route as AdminAiRouteImport } from './routes/_admin/ai'
import { Route as AdminAuditRouteImport } from './routes/_admin/audit'
import { Route as AdminFeedbackRouteImport } from './routes/_admin/feedback'
import { Route as AdminIntegrationsRouteImport } from './routes/_admin/integrations'
import { Route as AdminLawsRouteImport } from './routes/_admin/laws'
import { Route as AdminReviewRouteImport } from './routes/_admin/review'
import { Route as AdminSentryRouteImport } from './routes/_admin/sentry'
import { Route as AdminSubscriptionsRouteImport } from './routes/_admin/subscriptions'
import { Route as AdminSupportRouteImport } from './routes/_admin/support'
import { Route as AdminTemplatesRouteImport } from './routes/_admin/templates'
import { Route as AdminToolRequestsRouteImport } from './routes/_admin/tool-requests'
import { Route as AdminUsageRouteImport } from './routes/_admin/usage'
import { Route as AuthCheckEmailRouteImport } from './routes/_auth/check-email'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as AuthTwoFactorRouteImport } from './routes/_auth/two-factor'
import { Route as AdminCompaniesIndexRouteImport } from './routes/_admin/companies/index'
import { Route as AdminCompaniesIdRouteImport } from './routes/_admin/companies/$id'
import { Route as AdminSettingsIndexRouteImport } from './routes/_admin/settings/index'
import { Route as AdminUsersIndexRouteImport } from './routes/_admin/users/index'
import { Route as AdminUsersIdRouteImport } from './routes/_admin/users/$id'
import { Route as AdminSettingsAiToolsToolIdRouteImport } from './routes/_admin/settings/ai-tools/$toolId'
import { Route as AdminSettingsCustomToolsIdRouteImport } from './routes/_admin/settings/custom-tools/$id'

const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAiRoute = AdminAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeedbackRoute = AdminFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AdminRoute,
} as any)
const AdminIntegrationsRoute = AdminIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLawsRoute = AdminLawsRouteImport.update({
  id: '/laws',
  path: '/laws',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReviewRoute = AdminReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSentryRoute = AdminSentryRouteImport.update({
  id: '/sentry',
  path: '/sentry',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSubscriptionsRoute = AdminSubscriptionsRouteImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSupportRoute = AdminSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTemplatesRoute = AdminTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AdminRoute,
} as any)
const AdminToolRequestsRoute = AdminToolRequestsRouteImport.update({
  id: '/tool-requests',
  path: '/tool-requests',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsageRoute = AdminUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => AdminRoute,
} as any)
const AuthCheckEmailRoute = AuthCheckEmailRouteImport.update({
  id: '/check-email',
  path: '/check-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTwoFactorRoute = AuthTwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => AuthRoute,
} as any)
const AdminCompaniesIndexRoute = AdminCompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCompaniesIdRoute = AdminCompaniesIdRouteImport.update({
  id: '/companies/$id',
  path: '/companies/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsIndexRoute = AdminSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersIdRoute = AdminUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsAiToolsToolIdRoute =
  AdminSettingsAiToolsToolIdRouteImport.update({
    id: '/settings/ai-tools/$toolId',
    path: '/settings/ai-tools/$toolId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSettingsCustomToolsIdRoute =
  AdminSettingsCustomToolsIdRouteImport.update({
    id: '/settings/custom-tools/$id',
    path: '/settings/custom-tools/$id',
    getParentRoute: () => AdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AdminIndexRoute
  '/verify-email': typeof VerifyEmailRoute
  '/ai': typeof AdminAiRoute
  '/audit': typeof AdminAuditRoute
  '/feedback': typeof AdminFeedbackRoute
  '/integrations': typeof AdminIntegrationsRoute
  '/laws': typeof AdminLawsRoute
  '/review': typeof AdminReviewRoute
  '/sentry': typeof AdminSentryRoute
  '/subscriptions': typeof AdminSubscriptionsRoute
  '/support': typeof AdminSupportRoute
  '/templates': typeof AdminTemplatesRoute
  '/tool-requests': typeof AdminToolRequestsRoute
  '/usage': typeof AdminUsageRoute
  '/check-email': typeof AuthCheckEmailRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/two-factor': typeof AuthTwoFactorRoute
  '/companies/$id': typeof AdminCompaniesIdRoute
  '/users/$id': typeof AdminUsersIdRoute
  '/companies/': typeof AdminCompaniesIndexRoute
  '/settings/': typeof AdminSettingsIndexRoute
  '/users/': typeof AdminUsersIndexRoute
  '/settings/ai-tools/$toolId': typeof AdminSettingsAiToolsToolIdRoute
  '/settings/custom-tools/$id': typeof AdminSettingsCustomToolsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AdminIndexRoute
  '/verify-email': typeof VerifyEmailRoute
  '/ai': typeof AdminAiRoute
  '/audit': typeof AdminAuditRoute
  '/feedback': typeof AdminFeedbackRoute
  '/integrations': typeof AdminIntegrationsRoute
  '/laws': typeof AdminLawsRoute
  '/review': typeof AdminReviewRoute
  '/sentry': typeof AdminSentryRoute
  '/subscriptions': typeof AdminSubscriptionsRoute
  '/support': typeof AdminSupportRoute
  '/templates': typeof AdminTemplatesRoute
  '/tool-requests': typeof AdminToolRequestsRoute
  '/usage': typeof AdminUsageRoute
  '/check-email': typeof AuthCheckEmailRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/two-factor': typeof AuthTwoFactorRoute
  '/companies/$id': typeof AdminCompaniesIdRoute
  '/users/$id': typeof AdminUsersIdRoute
  '/companies': typeof AdminCompaniesIndexRoute
  '/settings': typeof AdminSettingsIndexRoute
  '/users': typeof AdminUsersIndexRoute
  '/settings/ai-tools/$toolId': typeof AdminSettingsAiToolsToolIdRoute
  '/settings/custom-tools/$id': typeof AdminSettingsCustomToolsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_admin': typeof AdminRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/verify-email': typeof VerifyEmailRoute
  '/_admin/ai': typeof AdminAiRoute
  '/_admin/audit': typeof AdminAuditRoute
  '/_admin/feedback': typeof AdminFeedbackRoute
  '/_admin/integrations': typeof AdminIntegrationsRoute
  '/_admin/laws': typeof AdminLawsRoute
  '/_admin/review': typeof AdminReviewRoute
  '/_admin/sentry': typeof AdminSentryRoute
  '/_admin/subscriptions': typeof AdminSubscriptionsRoute
  '/_admin/support': typeof AdminSupportRoute
  '/_admin/templates': typeof AdminTemplatesRoute
  '/_admin/tool-requests': typeof AdminToolRequestsRoute
  '/_admin/usage': typeof AdminUsageRoute
  '/_auth/check-email': typeof AuthCheckEmailRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/_auth/two-factor': typeof AuthTwoFactorRoute
  '/_admin/': typeof AdminIndexRoute
  '/_admin/companies/$id': typeof AdminCompaniesIdRoute
  '/_admin/users/$id': typeof AdminUsersIdRoute
  '/_admin/companies/': typeof AdminCompaniesIndexRoute
  '/_admin/settings/': typeof AdminSettingsIndexRoute
  '/_admin/users/': typeof AdminUsersIndexRoute
  '/_admin/settings/ai-tools/$toolId': typeof AdminSettingsAiToolsToolIdRoute
  '/_admin/settings/custom-tools/$id': typeof AdminSettingsCustomToolsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/verify-email'
    | '/ai'
    | '/audit'
    | '/feedback'
    | '/integrations'
    | '/laws'
    | '/review'
    | '/sentry'
    | '/subscriptions'
    | '/support'
    | '/templates'
    | '/tool-requests'
    | '/usage'
    | '/check-email'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/two-factor'
    | '/companies/$id'
    | '/users/$id'
    | '/companies/'
    | '/settings/'
    | '/users/'
    | '/settings/ai-tools/$toolId'
    | '/settings/custom-tools/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/verify-email'
    | '/ai'
    | '/audit'
    | '/feedback'
    | '/integrations'
    | '/laws'
    | '/review'
    | '/sentry'
    | '/subscriptions'
    | '/support'
    | '/templates'
    | '/tool-requests'
    | '/usage'
    | '/check-email'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/two-factor'
    | '/companies/$id'
    | '/users/$id'
    | '/companies'
    | '/settings'
    | '/users'
    | '/settings/ai-tools/$toolId'
    | '/settings/custom-tools/$id'
  id:
    | '__root__'
    | '/_admin'
    | '/_auth'
    | '/verify-email'
    | '/_admin/ai'
    | '/_admin/audit'
    | '/_admin/feedback'
    | '/_admin/integrations'
    | '/_admin/laws'
    | '/_admin/review'
    | '/_admin/sentry'
    | '/_admin/subscriptions'
    | '/_admin/support'
    | '/_admin/templates'
    | '/_admin/tool-requests'
    | '/_admin/usage'
    | '/_auth/check-email'
    | '/_auth/forgot-password'
    | '/_auth/reset-password'
    | '/_auth/sign-in'
    | '/_auth/sign-up'
    | '/_auth/two-factor'
    | '/_admin/'
    | '/_admin/companies/$id'
    | '/_admin/users/$id'
    | '/_admin/companies/'
    | '/_admin/settings/'
    | '/_admin/users/'
    | '/_admin/settings/ai-tools/$toolId'
    | '/_admin/settings/custom-tools/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AdminRoute: typeof AdminRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/': {
      id: '/_admin/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/ai': {
      id: '/_admin/ai'
      path: '/ai'
      fullPath: '/ai'
      preLoaderRoute: typeof AdminAiRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/audit': {
      id: '/_admin/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/feedback': {
      id: '/_admin/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof AdminFeedbackRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/integrations': {
      id: '/_admin/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AdminIntegrationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/laws': {
      id: '/_admin/laws'
      path: '/laws'
      fullPath: '/laws'
      preLoaderRoute: typeof AdminLawsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/review': {
      id: '/_admin/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof AdminReviewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/sentry': {
      id: '/_admin/sentry'
      path: '/sentry'
      fullPath: '/sentry'
      preLoaderRoute: typeof AdminSentryRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/subscriptions': {
      id: '/_admin/subscriptions'
      path: '/subscriptions'
      fullPath: '/subscriptions'
      preLoaderRoute: typeof AdminSubscriptionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/support': {
      id: '/_admin/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AdminSupportRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/templates': {
      id: '/_admin/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof AdminTemplatesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/tool-requests': {
      id: '/_admin/tool-requests'
      path: '/tool-requests'
      fullPath: '/tool-requests'
      preLoaderRoute: typeof AdminToolRequestsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/usage': {
      id: '/_admin/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof AdminUsageRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_auth/check-email': {
      id: '/_auth/check-email'
      path: '/check-email'
      fullPath: '/check-email'
      preLoaderRoute: typeof AuthCheckEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/two-factor': {
      id: '/_auth/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof AuthTwoFactorRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_admin/companies/': {
      id: '/_admin/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AdminCompaniesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/companies/$id': {
      id: '/_admin/companies/$id'
      path: '/companies/$id'
      fullPath: '/companies/$id'
      preLoaderRoute: typeof AdminCompaniesIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/settings/': {
      id: '/_admin/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AdminSettingsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/users/': {
      id: '/_admin/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/users/$id': {
      id: '/_admin/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AdminUsersIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/settings/ai-tools/$toolId': {
      id: '/_admin/settings/ai-tools/$toolId'
      path: '/settings/ai-tools/$toolId'
      fullPath: '/settings/ai-tools/$toolId'
      preLoaderRoute: typeof AdminSettingsAiToolsToolIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/settings/custom-tools/$id': {
      id: '/_admin/settings/custom-tools/$id'
      path: '/settings/custom-tools/$id'
      fullPath: '/settings/custom-tools/$id'
      preLoaderRoute: typeof AdminSettingsCustomToolsIdRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAiRoute: typeof AdminAiRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminFeedbackRoute: typeof AdminFeedbackRoute
  AdminIntegrationsRoute: typeof AdminIntegrationsRoute
  AdminLawsRoute: typeof AdminLawsRoute
  AdminReviewRoute: typeof AdminReviewRoute
  AdminSentryRoute: typeof AdminSentryRoute
  AdminSubscriptionsRoute: typeof AdminSubscriptionsRoute
  AdminSupportRoute: typeof AdminSupportRoute
  AdminTemplatesRoute: typeof AdminTemplatesRoute
  AdminToolRequestsRoute: typeof AdminToolRequestsRoute
  AdminUsageRoute: typeof AdminUsageRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCompaniesIdRoute: typeof AdminCompaniesIdRoute
  AdminUsersIdRoute: typeof AdminUsersIdRoute
  AdminCompaniesIndexRoute: typeof AdminCompaniesIndexRoute
  AdminSettingsIndexRoute: typeof AdminSettingsIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
  AdminSettingsAiToolsToolIdRoute: typeof AdminSettingsAiToolsToolIdRoute
  AdminSettingsCustomToolsIdRoute: typeof AdminSettingsCustomToolsIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAiRoute: AdminAiRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminFeedbackRoute: AdminFeedbackRoute,
  AdminIntegrationsRoute: AdminIntegrationsRoute,
  AdminLawsRoute: AdminLawsRoute,
  AdminReviewRoute: AdminReviewRoute,
  AdminSentryRoute: AdminSentryRoute,
  AdminSubscriptionsRoute: AdminSubscriptionsRoute,
  AdminSupportRoute: AdminSupportRoute,
  AdminTemplatesRoute: AdminTemplatesRoute,
  AdminToolRequestsRoute: AdminToolRequestsRoute,
  AdminUsageRoute: AdminUsageRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminCompaniesIdRoute: AdminCompaniesIdRoute,
  AdminUsersIdRoute: AdminUsersIdRoute,
  AdminCompaniesIndexRoute: AdminCompaniesIndexRoute,
  AdminSettingsIndexRoute: AdminSettingsIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
  AdminSettingsAiToolsToolIdRoute: AdminSettingsAiToolsToolIdRoute,
  AdminSettingsCustomToolsIdRoute: AdminSettingsCustomToolsIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AuthRouteChildren {
  AuthCheckEmailRoute: typeof AuthCheckEmailRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  AuthTwoFactorRoute: typeof AuthTwoFactorRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCheckEmailRoute: AuthCheckEmailRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  AuthTwoFactorRoute: AuthTwoFactorRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AdminRoute: AdminRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
